import React, { useState, useEffect } from "react";
import Overviewbar from "./Overviewbar";
import "../cssfiles/homepage.css";
import LeftPane from "./LeftPane";
import Dashboard from "./Dashboard";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import { Box, Stack } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import Typography from "@mui/material/Typography";
import Year from "./CommonComponents/Year";
import Searchall from "./CommonComponents/Search";
import RightPane from "./RightPane";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { updatedateselection_sdate_edate, updateselecteddates_dashboard } from "../store/mainpage_data";

export default function Mainpage() {
  const dispatch = useDispatch();
  const overviewstate = useSelector(
    (state) => state.mainpagedata.overviewbarstate
  );
  const selectedtreepath = useSelector(
    (state) => state.mainpagedata.treepathselected
  );
  const tabpathselected = useSelector(
    (state) => state.mainpagedata.selectedtabpath
  );
  const path = useSelector((state) => state.mainpagedata.selectedpath);

  const [pagesize, setPagesize] = useState(330);
  const [pathselected, setPathselected] = useState([
    <Typography
      key="Dashboards"
      className="crumbs"
      style={{ fontSize: "14px", fontWeight: 400 }}
    >
      Plant
    </Typography>,
    <Typography
      key="Dashboards"
      className="crumbs"
      style={{ fontSize: "14px", fontWeight: 400 }}
    >
      Dashboard
    </Typography>,
    <Typography
      key="Dashboards"
      className="crumbs"
      style={{ fontSize: "14px", fontWeight: 400 }}
    >
      Dashboard
    </Typography>,
  ]);

  useEffect(() => {
    //console.log("overviewstate ",overviewstate)
    if (overviewstate) {
      setPagesize(261);
    } else {
      setPagesize(226);
    }
  }, [overviewstate]);

  useEffect(() => {
    const now = new Date();
    var startdate = new Date(now);
    startdate.setHours(0, 0, 0, 0); // Start of today
    var enddate = new Date(now);
    enddate.setHours(23, 59, 59, 999); // End of today
    var startdate_dashboard = startdate;
    var enddate_dashboard = enddate;
    const intialdate = new Date();
    const secondszero = new Date(intialdate.setHours(0, 0, 0));
    var todayepoc = Math.floor(secondszero / 1000);
    var todatendepoc = todayepoc + 23 * 60 * 60 + 59 * 60 + 59;

    startdate = todayepoc;
    enddate = todatendepoc;
    
    // Update both date states for consistency
    dispatch(
      updatedateselection_sdate_edate({
        selectedstartdate: startdate,
        selectedenddate: enddate,
        selectedrepstartdate: new Date(now.setHours(0, 0, 0, 0)).toString(),
        selectedrependdate: new Date().toString(),
      })
    );
    
    // Initialize selecteddates_dashboard that Dashboard.js listens to
    dispatch(
      updateselecteddates_dashboard({
        selectedstartdate_dashboard: startdate_dashboard,
        selectedenddate_dashboard: enddate_dashboard,
      })
    );
  }, []);

  //console.log("path",path)
  useEffect(() => {
    var newpath = [];
    for (let i = 0; i < selectedtreepath.length; i++) {
      newpath.push(
        <Typography
          key="Dashboards"
          className="crumbs"
          style={{ fontSize: "14px", fontWeight: 400 }}
        >
          {selectedtreepath[i]}
        </Typography>
      );
    }
    for (let i = 0; i < tabpathselected.length; i++) {
      newpath.push(
        <Typography
          key="Dashboards"
          className="crumbs"
          style={{ fontSize: "14px", fontWeight: 400 }}
        >
          {tabpathselected[i]}
        </Typography>
      );
    }
    setPathselected(newpath);
  }, [selectedtreepath, path, tabpathselected]);

  var doubleright = ">>";

  return (
    <Box className="mainpage">
      <Overviewbar />
      <div style={{ display: "flex", flexDirection: "row", width: "100%" }}>
        <div
          className="breadcrumb"
          style={{ flexGrow: 1, marginRight: "4px", marginLeft: "16px" }}
        >
          <Breadcrumbs
            separator={
              <NavigateNextIcon
                fontSize="small"
                sx={{ color: "var(--GreyVariation_2)" }}
              />
            }
            style={{ padding: "10px 12px 10px 12px", textAlign: "center" }}
          >
            {pathselected}
          </Breadcrumbs>
        </div>
        <Searchall />
        <Year />
      </div>
      <Box
        style={{
          display: "flex",
          flexDirection: "row",
          height: `calc(100vh - ${pagesize}px)`,
          padding: "0px 16px",
        }}
      >
        <LeftPane />
        <Dashboard />
        <RightPane />
      </Box>
    </Box>
  );
}
